const textStyles: { [styleName: string]: string } = {
  textStyleH1: `
  font-size: 65px;
  font-family: 'Overpass';
  font-weight: normal;
  font-style: normal;
  line-height: 80px;
  text-decoration: none;
`,
  textStyleH2: `
  font-size: 48px;
  font-family: 'Overpass';
  font-weight: normal;
  font-style: normal;
  line-height: 70px;
  text-decoration: none;
`,
  textStyleH3: `
  font-size: 40px;
  font-family: 'Open Sans';
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
`,
  textStyleH4: `
  font-size: 30px;
  font-family: 'Overpass';
  font-weight: bolder;
  font-style: normal;
  text-decoration: none;
`,
  textStyleBigParagraph: `
  font-size: 22px;
  font-family: 'Open Sans';
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
`,
  textStyleSmallParagraph: `
  font-size: 16px;
  font-family: 'Open Sans';
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
`,
}
export default textStyles
